class Device {
    static init() {
        this.html = document.querySelector("html");

        window.addEventListener("resize", this.check.bind(this));
        //window.addEventListener("orientationchange", this.check.bind(this));
        this.check();
    }

    static check() {
        
        this.isTouch = this.isTouchDevice();
        this.isLandscape = (window.innerWidth > window.innerHeight);

        this.isMobile = (window.innerWidth < 992);
        this.isDesktop = (window.innerWidth >= 992);

        this.isIOS = (navigator.userAgent.indexOf("iPad") != -1) || (navigator.userAgent.indexOf("iPhone") != -1) || (navigator.userAgent.indexOf("iPod") != -1);
        this.isChrome = !!window.chrome;
        this.isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
        this.isEdge = (/Edge/.test(navigator.userAgent));

        Device.toggleClass(this.html, this.isMobile, "device__mobile");
        Device.toggleClass(this.html, this.isDesktop, "device__desktop");
        Device.toggleClass(this.html, this.isTouch, "device__touch");
        Device.toggleClass(this.html, this.isIE11, "device__ie11");
        Device.toggleClass(this.html, this.isEdge, "device__edge");
    }

    static isTouchDevice () {
        var result = false;
        if (window.PointerEvent && ('maxTouchPoints' in navigator)) {
            if (navigator.maxTouchPoints > 0) {
                result = true;
            }
        } else {
            if (window.matchMedia && window.matchMedia("(any-pointer:coarse)").matches) {
                result = true;
            } else if (window.TouchEvent || ('ontouchstart' in window)) {
                result = true;
            }
        }
        return result;
    }

    static toggleClass(element, condition, className) {
        if (condition) {
            element.classList.add(className);
        } else {
            element.classList.remove(className);
        }
    }

    static getCurrent() {
        if (Device.isDesktop) {
            return "desktop";
        } else {
            return "mobile";
        }
    }
}

export default Device;


// WEBPACK FOOTER //
// ./src/scripts/common/device.js